import React from 'react';

const Flash = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M23.88 14.2929H19.76V4.69287C19.76 2.45287 18.5467 1.99954 17.0667 3.67954L16 4.89287L6.97335 15.1595C5.73335 16.5595 6.25335 17.7062 8.12002 17.7062H12.24V27.3062C12.24 29.5462 13.4533 29.9995 14.9333 28.3195L16 27.1062L25.0267 16.8395C26.2667 15.4395 25.7467 14.2929 23.88 14.2929Z",
      fill: "#00FFFF"
    }
  )
);

export { Flash };
//# sourceMappingURL=Flash.js.map
